import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import io from "socket.io-client";
import SendIcon from "@mui/icons-material/Send";
import {
  Avatar,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useGetUnreadMessagesQuery, useMarkMessagesAsReadMutation } from "../../../Api/apiSlice";
import { useDispatch } from "react-redux";
import { setNotification } from "../../../Api/notificationSlice";
// const socket = io("https://logisticsgpslive.com");
const socket = io(process.env.REACT_APP_API_URL);

socket.on("connect", () => {
  console.log("Connected to server with socket id:", socket.id);
});

socket.on("connect_error", (err) => {
  console.error("Socket connection error:", err);
});
const CustomerChatCopy = () => {
  const dispatch = useDispatch();
  const { data: unreadMessages, isLoading: isUnreadMessagesLoading } = useGetUnreadMessagesQuery();
  const [markMessagesAsRead] = useMarkMessagesAsReadMutation();
  const [chatId, setChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const userId = localStorage.getItem("userId");
  const organizationId = localStorage.getItem("organizationId");
  const apiUrl = process.env.REACT_APP_API_URL;
  const userName = localStorage.getItem("userName");

  // Set notification to false when component mounts
  // useEffect(() => {
  //   dispatch(setNotification(false));
  // }, [dispatch]);

  // Initialize the chat
  useEffect(() => {
    const initializeChat = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.post(
          `${apiUrl}/api/admin/chat`,
          {
            userId,
            organizationId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setChatId(response.data.chat.id);
        markMessagesAsRead(response.data.chat.id);
        dispatch(setNotification(false));
        // Join the chat room using socket.io
        socket.emit("join_chat", response.data.chat.id);
      } catch (error) {
        console.error("Error initializing chat:", error);
      }
    };

    initializeChat();
  }, []);

  // Fetch messages for the current chat
  useEffect(() => {
    const fetchMessages = async () => {
      if (!chatId) return;

      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          `${apiUrl}/api/admin/chat/${chatId}/messages`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setMessages(response.data.messages);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, [chatId]);

  // Listen for new messages from socket.io
  useEffect(() => {
    socket.on("new_message", (data) => {
      if (data.chatId === chatId) {
        setMessages((prev) => [...prev, data.message]);
      }
    });

    return () => {
      socket.off("new_message");
    };
  }, [chatId]);

  // Handle sending a new message
  const token = localStorage.getItem("authToken");

  const handleSendMessage = async () => {
    if (!newMessage.trim() || !chatId) return;

    // Emit to backend for broadcast to admins
    socket.emit("send_message", {
      chatId,
      content: newMessage,
      senderId: userId,
      isAdmin: false,
      organizationId,
    });
    setNewMessage("");
    // } catch (error) {
    //   console.error("Error sending message:", error);
    // }
  };
  const messagesEndRef = useRef(null);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      height="calc(100vh - 5.4rem)"
      sx={{ backgroundColor: "#f5f5f5", marginTop: "5.4rem" }}
    >
      {/* User List */}

      {/* Chat Box */}
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        sx={{
          backgroundColor: "#fff",
          borderLeft: { md: "1px solid #ddd" },
          borderRight: { md: "1px solid #ddd" },
        }}
      >
        {/* Messages */}
        <Box
          flex={1}
          sx={{
            p: 2,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {messages.map((msg, idx) => (
            <Box
              key={idx}
              sx={{
                alignSelf: msg.isAdmin ? "flex-end" : "flex-start",
                maxWidth: "70%",
                borderRadius: 2,
                padding: 1.5,
                backgroundColor: msg.isAdmin ? "#1976d2" : "#f1f0f0",
                color: msg.isAdmin ? "#fff" : "#000",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                {msg.isAdmin ? "Admin" : userName}
              </Typography>
              <Typography variant="body2">{msg.content}</Typography>
            </Box>
          ))}
          <div ref={messagesEndRef} />
        </Box>

        {/* Input and Send Button */}
        {chatId && (
          <Box
            display="flex"
            alignItems="center"
            p={2}
            sx={{
              borderTop: "1px solid #ddd",
            }}
          >
            <TextField
              fullWidth
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Type a message..."
              variant="outlined"
              size="small"
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendMessage}
              sx={{ ml: 2 }}
              endIcon={<SendIcon />}
            >
              Send
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CustomerChatCopy;
